export default "__VITE_ASSET__CkWtDslo__"